
export class AsociadoSituacion{

  id: number
  nombre: string
  activo: string;

  constructor() {
    this.id = 0;
    this.nombre = '';
    this.activo = '';
  }

 }
